/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import classNames from 'classnames';
import { HOTEL_CARD_TITLE } from '../../constants';
import styles from './hotelCardTitle.module.css';

type HotelCardTitleProps = {
  children: string;
  isMobile: boolean;
  hotelPageHref: string;
  isMapCard?: boolean;
  openInCurrentTab: boolean;
};

const HotelCardTitle: React.FC<HotelCardTitleProps> = ({
  children,
  isMobile,
  hotelPageHref,
  isMapCard = false,
  openInCurrentTab,
}) => (
  <a
    className={classNames(styles.title, {
      [styles.titleMobile]: isMobile,
      [styles.titleMapCard]: isMapCard,
    })}
    href={hotelPageHref}
    target={openInCurrentTab ? '_self' : '_blank'}
    data-testid={HOTEL_CARD_TITLE}
    itemProp="name"
  >
    {children}
  </a>
);

export default HotelCardTitle;
